import React, { useState } from 'react';

const TripjackSupplierHighlight = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [billingCycle, setBillingCycle] = useState(1); // 1 = Monthly, 2 = Annually

  // Company Information - Zotrai (YOUR COMPANY)
  const companyInfo = {
    name: "Zotrai",
    themeColor: "#FF7F00",
    description: "Your trusted B2B travel technology partner",
    founded: "2020",
    headquarters: "India",
    agents: "10,000+",
    suppliers: "50+",
    countries: "100+",
    uptime: "99.9%",
    apiCalls: "100M+",
    team: "100+",
    email: "support@zotrai.com",
    phone: "+91-7207642485"
  };

  // Why Suppliers Choose Zotrai - REAL DATA
  const whyZotraiData = {
    benefits: [
        {
        id: 1,
        title: "Single API Integration, Multiple Connections",
        description: "Connect once with Zotrai and get instant access to all our partner suppliers - no multiple integrations needed",
        icon: "ri-plug-line",
        stat: "1",
        statLabel: "Integration"
      },
     {
  id: 2,
  title: "Launch B2B, B2C & Corporate Portals",
  description: "Fully customizable multi-agent, direct-sell, and corporate booking platforms under your brand",
  icon: "ri-window-line",
  stat: "All-in-One",
  statLabel: "Portal Suite"
},
    
      {
  id: 3,
  title: "Save 95% on Integration Costs",
  description: "No setup fees, no integration charges.",
icon: "ri-coins-line",

  stat: "95%",
  statLabel: "Cost Savings"
},
      {
        id: 4,
        title: "Real-time Analytics Dashboard",
        description: "Track your inventory performance, booking patterns, and agent behavior with detailed analytics",
        icon: "ri-bar-chart-2-line",
        stat: "24/7",
        statLabel: "Monitoring"
      },
      {
        id: 5,
        title: "99.9% Uptime Guarantee",
        description: "Enterprise-grade infrastructure with redundant systems ensuring your APIs are always available",
        icon: "ri-shield-check-line",
        stat: "99.9%",
        statLabel: "Uptime"
      },
      {
        id: 6,
        title: "Dedicated Account Manager",
        description: "Every supplier gets a dedicated technical account manager for seamless integration and support",
        icon: "ri-customer-service-line",
        stat: "24/7",
        statLabel: "Support"
      }
    ],
    process: [
      {
        step: 1,
        title: "Add Your API Credentials",
        description: "Just Login, paste your API keys, and we handle the rest – zero development effort"
      },
       {
        step: 2,
        title: "Select & Customize Template",
        description: "Pick from our library of 100+ responsive templates and match your brand identity"
      },
      {
        step: 3,
        title: "Go Live Instantly",
        description: "Deploy to production in one click and start accepting real bookings"
      }
    ]
  };

  // SEO-friendly structured data for Tripjack
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Tripjack",
    "description": "Leading travel technology supplier and API integration provider for travel businesses",
    "url": "https://www.tripjack.com",
    "areaServed": "Worldwide",
    "serviceType": ["Flight Booking API", "Hotel Booking API", "Travel Technology Solutions"],
    "foundingDate": "2018",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Gurgaon",
      "addressCountry": "India"
    }
  };

  // Tripjack specific data
  const tripjackData = {
    name: "Tripjack",
    description: "Leading travel technology supplier and API integration provider for travel businesses, offering comprehensive solutions for flights, hotels, and holiday packages.",
    longDescription: "Tripjack is a premier travel technology supplier that has revolutionized how travel businesses access and distribute travel inventory. Founded in 2018, Tripjack has rapidly grown to become one of the most trusted API integration providers in the travel industry. Their comprehensive platform offers seamless integration capabilities for flights, hotels, holiday packages, and other travel services through a single, powerful API. Tripjack connects travel agents, tour operators, and online travel agencies with a vast network of global suppliers, including multiple GDS connections, direct airline integrations, and extensive hotel inventory. Known for their robust technology infrastructure, real-time pricing engine, and instant confirmation capabilities, Tripjack empowers travel companies with the tools they need to scale their operations efficiently. Their commitment to innovation, reliability, and customer success has made them the preferred technology partner for thousands of travel businesses worldwide.",
    founded: "2018",
    headquarters: "Gurgaon, India",
    employees: "200+",
    countries: "100+",
    airlines: "80+",
    hotels: "500K+",
    gdsConnections: ["Amadeus", "Sabre", "Travelport"],
    apiCalls: "100M+",
    agents: "5,000+",
    themeColor: "#2563eb", // Blue color
    website: "https://www.tripjack.com",
    apiType: "RESTful API",
    integrationType: "Direct API Integration",
    support: "24/7 Technical Support"
  };

  // Key features of Tripjack
  const features = [
    {
      icon: "✈️",
      title: "80+ Airlines",
      description: "Access to global flight inventory through multiple GDS connections and direct airline integrations"
    },
    {
      icon: "🏨",
      title: "500K+ Hotels",
      description: "Extensive hotel inventory with real-time availability, dynamic pricing, and instant confirmation"
    },
    {
      icon: "🔄",
      title: "Multi-GDS Integration",
      description: "Seamless connectivity with Amadeus, Sabre, and Travelport through a single API"
    },
    {
      icon: "⚡",
      title: "Real-time Pricing",
      description: "Dynamic pricing engine with real-time fare updates and best price guarantees"
    }
  ];

  // Services offered by Tripjack
  const services = [
    {
      id: 1,
      title: "Flight Booking API",
      description: "Access to 80+ airlines with real-time pricing, availability, and seamless booking capabilities through multiple GDS connections.",
      features: [
        "Multiple GDS connections",
        "Real-time fare updates",
        "Advanced search filters",
        "PNR generation",
        "Seat selection",
        "Meal preferences"
      ],
      icon: "✈️"
    },
    {
      id: 2,
      title: "Hotel Booking API",
      description: "Extensive hotel inventory with 500K+ properties, detailed information, images, and instant booking confirmation.",
      features: [
        "Global property network",
        "Dynamic pricing engine",
        "Rich content & media",
        "Cancellation policies",
        "Room upgrades",
        "Special requests"
      ],
      icon: "🏨"
    },
    {
      id: 3,
      title: "Holiday Packages ",
      description: "Comprehensive holiday package solutions combining flights, hotels, and activities with dynamic packaging.",
      features: [
        "Dynamic packaging",
        "Custom itineraries",
        "Group packages",
        "Seasonal offers",
        "Early bird discounts",
        "Last minute deals"
      ],
      icon: "🌴"
    },
    {
      id: 4,
      title: "Car Rental ",
      description: "Global car rental inventory from leading providers with flexible pickup and dropoff options.",
      features: [
        "Global coverage",
        "Multiple vehicle types",
        "Insurance options",
        "GPS navigation",
        "Child seats",
        "Unlimited mileage"
      ],
      icon: "🚗"
    },
    {
      id: 5,
      title: "Travel Insurance",
      description: "Comprehensive travel insurance solutions with multiple coverage options and instant policy issuance.",
      features: [
        "Multiple coverage plans",
        "Instant policy issuance",
        "Claim assistance",
        "24/7 emergency support",
        "Trip cancellation cover",
        "Medical coverage"
      ],
      icon: "🛡️"
    },
    {
      id: 6,
      title: "Sightseeing",
      description: "Access to thousands of sightseeing tours, activities, and attractions at destinations worldwide.",
      features: [
        "Global destinations",
        "Skip-the-line tickets",
        "Guided tours",
        "Local experiences",
        "Audio guides",
        "Mobile tickets"
      ],
      icon: "🎫"
    }
  ];

  // Technology highlights
  const technology = [
    {
      title: "RESTful APIs",
      description: "Modern RESTful API architecture with comprehensive documentation and versioning"
    },
    {
      title: "Multi-GDS Integration",
      description: "Single API connecting to Amadeus, Sabre, and Travelport"
    },
    {
      title: "Real-time Data",
      description: "Live inventory and pricing from all connected suppliers"
    },
    {
      title: "Webhook Support",
      description: "Real-time notifications for booking updates and status changes"
    },
    {
      title: "Scalable Architecture",
      description: "Enterprise-grade infrastructure handling millions of API calls"
    },
    {
      title: "High Availability",
      description: "99.9% uptime with redundant systems and automatic failover"
    }
  ];

  // Integration process
  const integrationProcess = [
    {
      step: 1,
      title: "API Documentation",
      description: "Receive comprehensive API documentation and credentials"
    },
    {
      step: 2,
      title: "Sandbox Testing",
      description: "Test integration in Tripjack's staging environment"
    },
    {
      step: 3,
      title: "Go Live",
      description: "Deploy to production with 24/7 technical support"
    }
  ];

  // Why choose Tripjack
  const whyChoose = [
    "Multi-GDS integration through a single API",
    "80+ airlines with real-time pricing",
    "500K+ hotel properties worldwide",
    "99.9% uptime guarantee",
    "Instant booking confirmation",
    "24/7 dedicated technical support"
  ];

  // Supplier logos array with navigation paths
  const suppliers = [
    { 
      id: 1, 
      name: "Tripjack", 
      logo: "/assets/images/suppliers/tripjack.png",
      path: "/supplier/tripjack"
    },
    { 
      id: 2, 
      name: "TBO", 
      logo: "/assets/images/suppliers/tbo.png",
      path: "/supplier/tbo"
    },
    { 
      id: 3, 
      name: "Akbar Travels", 
      logo: "/assets/images/suppliers/akbar.png",
      path: "/supplier/akbar-travels"
    },
    { 
      id: 4, 
      name: "RezLive", 
      logo: "/assets/images/suppliers/rezlive.png",
      path: "/supplier/rezlive"
    },
    { 
      id: 5, 
      name: "GRN Connect", 
      logo: "/assets/images/suppliers/grn.png",
      path: "/supplier/grn-connect"
    },
    { 
      id: 6, 
      name: "Riya Travel", 
      logo: "/assets/images/suppliers/riya.png",
      path: "/supplier/riya-travel"
    },
    { 
      id: 7, 
      name: "Viator", 
      logo: "/assets/images/suppliers/viator.png",
      path: "/supplier/viator"
    },
    { 
      id: 8, 
      name: "Air iQ", 
      logo: "/assets/images/suppliers/airiq.png",
      path: "/supplier/air-iq"
    }
  ];

  // Pricing plans data
  const plans = [
    {
      id: 1,
      name: "Starter",
      description: "🚀 All-in-one powerful plan with complete access to every feature.",
      monthly: 2999,
      annually: 29999,
      popular: true,
      emoji: "🚀",
      features: [
        "Search, compare, and book flights from top global suppliers in one place",
        "Access and connect with 1,000+ verified global DMCs",
        "Smart accounting suite with ledgers, invoices, supplier settlements, and corporate payments",
        "Capture leads directly from social media and run promotions from a single dashboard",
        "Generate professional itineraries in minutes using AI",
        "AI-powered visa processing and document management system",
        "One unified platform for Flights, Hotels, Visas, Cars, Sightseeing, and more",
        "Integrated and secure payment gateway",
        "Plug in and manage your own supplier APIs seamlessly",
        "AI-based WhatsApp automation for leads, follow-ups, and customer support",
        "Unlimited email marketing and promotional campaigns",
        "Advanced reports and analytics for sales, revenue, and performance tracking",
      ],
      addons: [
        "Launch your own B2C booking website for customers in minutes – just INR 999",
        "Launch a full-featured B2C travel portal with flights, hotels, and packages using your preferred suppliers – INR 1,999",
        "Launch a B2B travel portal for your agent network with flights, hotels, and packages – INR 1,999",
        "Launch a B2E corporate travel portal for your business clients with flights, hotels, and packages – INR 1,999",
      ],
    },
  ];

  const getAccentColor = (planName) => {
    if (planName === "Starter") return "#10B981";
    if (planName === "Pro") return "#3B82F6";
    return "#8B5CF6";
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${companyInfo.email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${companyInfo.phone.replace(/[^0-9+]/g, '')}`;
  };

  const handleSupplierClick = (path) => {
    window.location.href = path;
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Tripjack - Leading Travel Technology Supplier | Zotrai</title>
        <meta name="description" content="Tripjack is a leading travel technology supplier offering comprehensive API integrations for flights, hotels, and holiday packages through Zotrai." />
        <meta name="keywords" content="Tripjack supplier, travel technology, flight booking API, hotel API, GDS integration, travel solutions" />
        <link rel="canonical" href="https://yourcompany.com/supplier/tripjack" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="Tripjack - Leading Travel Technology Supplier" />
        <meta property="og:description" content="Connect with Tripjack's comprehensive travel inventory through Zotrai's single API integration." />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Main Content with tripjack- prefix */}
      <div className="tripjack-supplier-container">
        {/* Header Section - Tripjack Hero */}
        <header className="tripjack-header">
          <div className="tripjack-container">
            <h1 className="tripjack-title">
              <span className="tripjack-highlight" style={{ color: tripjackData.themeColor }}>Tripjack</span>
              <br />
              Leading Travel Technology Supplier
            </h1>
            <p className="tripjack-subtitle">
              {tripjackData.description}
            </p>
          </div>
        </header>

        {/* Tabs Navigation - Same as others */}
        <div className="tripjack-tabs-container">
          <div className="tripjack-container">
            <div className="tripjack-tabs">
              <button 
                className={`tripjack-tab ${activeTab === 'about' ? 'tripjack-tab-active' : ''}`}
                onClick={() => setActiveTab('about')}
              >
                About
              </button>
              <button 
                className={`tripjack-tab ${activeTab === 'services' ? 'tripjack-tab-active' : ''}`}
                onClick={() => setActiveTab('services')}
              >
                Services
              </button>
              <button 
                className={`tripjack-tab ${activeTab === 'technology' ? 'tripjack-tab-active' : ''}`}
                onClick={() => setActiveTab('technology')}
              >
                Technology
              </button>
              <button 
                className={`tripjack-tab ${activeTab === 'whyzotrai' ? 'tripjack-tab-active' : ''}`}
                onClick={() => setActiveTab('whyzotrai')}
              >
                Why Zotrai <span className="tripjack-tab-badge">For Suppliers</span>
              </button>
              <button 
                className={`tripjack-tab ${activeTab === 'suppliers' ? 'tripjack-tab-active' : ''}`}
                onClick={() => setActiveTab('suppliers')}
              >
                Suppliers
              </button>
              <button 
                className={`tripjack-tab ${activeTab === 'pricing' ? 'tripjack-tab-active' : ''}`}
                onClick={() => setActiveTab('pricing')}
              >
                Pricing
              </button>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="tripjack-tab-content">
          {activeTab === 'about' && (
            <section className="tripjack-about">
              <div className="tripjack-container">
                <div className="tripjack-grid">
                  <div className="tripjack-about-content">
                    <h2 className="tripjack-section-title">About <span className="tripjack-accent" style={{ color: tripjackData.themeColor }}>Tripjack</span></h2>
                    <p className="tripjack-text">
                      {tripjackData.longDescription}
                    </p>
                    
                    <div className="tripjack-features">
                      {features.map((feature, index) => (
                        <div key={index} className="tripjack-feature">
                          <span className="tripjack-feature-icon">{feature.icon}</span>
                          <div>
                            <h4>{feature.title}</h4>
                            <p>{feature.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="tripjack-card">
                    <h3 className="tripjack-card-title">Tripjack at a Glance</h3>
                    <ul className="tripjack-list">
                      <li className="tripjack-list-item">
                        <span className="tripjack-check" style={{ color: tripjackData.themeColor }}>✓</span>
                        Founded 2018 • 5+ Years of Excellence
                      </li>
                      <li className="tripjack-list-item">
                        <span className="tripjack-check" style={{ color: tripjackData.themeColor }}>✓</span>
                        80+ Airline Connections
                      </li>
                      <li className="tripjack-list-item">
                        <span className="tripjack-check" style={{ color: tripjackData.themeColor }}>✓</span>
                        500K+ Hotel Properties
                      </li>
                      <li className="tripjack-list-item">
                        <span className="tripjack-check" style={{ color: tripjackData.themeColor }}>✓</span>
                        Multi-GDS Integration (Amadeus, Sabre, Travelport)
                      </li>
                      <li className="tripjack-list-item">
                        <span className="tripjack-check" style={{ color: tripjackData.themeColor }}>✓</span>
                        100+ Countries Coverage
                      </li>
                      <li className="tripjack-list-item">
                        <span className="tripjack-check" style={{ color: tripjackData.themeColor }}>✓</span>
                        5,000+ Active Agents
                      </li>
                      <li className="tripjack-list-item">
                        <span className="tripjack-check" style={{ color: tripjackData.themeColor }}>✓</span>
                        99.9% Uptime Guarantee
                      </li>
                      <li className="tripjack-list-item">
                        <span className="tripjack-check" style={{ color: tripjackData.themeColor }}>✓</span>
                        24/7 Technical Support
                      </li>
                    </ul>

                    <h3 className="tripjack-card-title tripjack-mt-4">GDS Connections</h3>
                    <div className="tripjack-gds-tags">
                      {tripjackData.gdsConnections.map((gds, index) => (
                        <span key={index} className="tripjack-gds-tag">{gds}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'services' && (
            <section className="tripjack-services">
              <div className="tripjack-container">
                <h2 className="tripjack-section-title tripjack-text-center">
                  Comprehensive Travel Solutions
                </h2>
                <p className="tripjack-section-subtitle">
                  Through our integration with Tripjack, we deliver end-to-end travel technology solutions
                </p>

                <div className="tripjack-services-grid">
                  {services.map((service) => (
                    <div key={service.id} className="tripjack-service-card">
                      <div className="tripjack-service-icon">{service.icon}</div>
                      <h3 className="tripjack-service-title">{service.title}</h3>
                      <p className="tripjack-service-description">{service.description}</p>
                      <ul className="tripjack-service-list">
                        {service.features.map((feature, index) => (
                          <li key={index} className="tripjack-service-list-item">
                            <span className="tripjack-dot" style={{ color: tripjackData.themeColor }}>•</span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {activeTab === 'technology' && (
            <section className="tripjack-technology">
              <div className="tripjack-container">
                <div className="tripjack-grid">
                  <div className="tripjack-integration-box">
                    <h3 className="tripjack-card-title">Seamless Integration</h3>
                    <p className="tripjack-text">
                      Our integration with Tripjack's robust APIs ensures smooth data flow, real-time updates, and reliable performance. This technology partnership enables us to deliver exceptional travel services.
                    </p>
                    <div className="tripjack-tags">
                      {technology.map((tech, index) => (
                        <span key={index} className="tripjack-tag">{tech.title}</span>
                      ))}
                    </div>
                  </div>

                  <div className="tripjack-benefits-box">
                    <h3 className="tripjack-card-title">Key Advantages</h3>
                    <ul className="tripjack-benefits-list">
                      <li className="tripjack-benefits-item">
                        <span className="tripjack-benefits-icon">⚡</span>
                        Lightning-fast API response times
                      </li>
                      <li className="tripjack-benefits-item">
                        <span className="tripjack-benefits-icon">🛡️</span>
                        Enterprise-grade security protocols
                      </li>
                      <li className="tripjack-benefits-item">
                        <span className="tripjack-benefits-icon">🎧</span>
                        Dedicated technical support
                      </li>
                      <li className="tripjack-benefits-item">
                        <span className="tripjack-benefits-icon">👥</span>
                        Experienced integration team
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'whyzotrai' && (
            <section className="tripjack-why-zotrai-section">
              <div className="tripjack-container">
                {/* Header */}
                <div className="tripjack-why-header">
                  <span className="tripjack-why-badge" style={{ background: `${companyInfo.themeColor}15`, color: companyInfo.themeColor }}>
                    <i className="ri-question-line"></i> WHY SUPPLIERS CHOOSE ZOTRAI
                  </span>
                  <h2 className="tripjack-section-title">
                    Your Growth Partner in <span className="tripjack-accent" style={{ color: companyInfo.themeColor }}>Travel Distribution</span>
                  </h2>
                  <p className="tripjack-section-subtitle">
                    Join 50+ leading travel suppliers who trust us to connect them with travel agents
                  </p>
                </div>

                {/* Benefits Grid */}
                <div className="tripjack-benefits-grid-full">
                  {whyZotraiData.benefits.map((benefit) => (
                    <div key={benefit.id} className="tripjack-benefit-card">
                      <div className="tripjack-benefit-icon-wrapper" style={{ background: `${companyInfo.themeColor}15` }}>
                        <i className={benefit.icon} style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="tripjack-benefit-content">
                        <h3>{benefit.title}</h3>
                        <p>{benefit.description}</p>
                        <div className="tripjack-benefit-stat">
                          <span className="tripjack-stat-highlight" style={{ color: companyInfo.themeColor }}>{benefit.stat}</span>
                          <span className="tripjack-stat-label">{benefit.statLabel}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Integration Process */}
                <div className="tripjack-integration-process">
                  <h3 className="tripjack-process-title">Simple 3-Step Integration</h3>
                  <div className="tripjack-process-steps">
                    {whyZotraiData.process.map((step) => (
                      <div key={step.step} className="tripjack-process-step">
                        <div className="tripjack-step-number" style={{ background: companyInfo.themeColor }}>{step.step}</div>
                        <h4>{step.title}</h4>
                        <p>{step.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Contact Section */}
                <div className="tripjack-contact-section">
                  <h3>Ready to Join Our Supplier Network?</h3>
                  <p>Connect with agents through a single integration</p>
                  
                  <div className="tripjack-contact-info">
                    <div className="tripjack-contact-item" onClick={handleEmailClick}>
                      <div className="tripjack-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-mail-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="tripjack-contact-details">
                        <span className="tripjack-contact-label">Email Support</span>
                        <span className="tripjack-contact-value">{companyInfo.email}</span>
                      </div>
                    </div>

                    <div className="tripjack-contact-item" onClick={handlePhoneClick}>
                      <div className="tripjack-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-phone-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="tripjack-contact-details">
                        <span className="tripjack-contact-label">Phone Support</span>
                        <span className="tripjack-contact-value">{companyInfo.phone}</span>
                      </div>
                    </div>
                  </div>

                  <p className="tripjack-contact-note">
                    Our support team is available 24/7 to assist you with any questions
                  </p>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'suppliers' && (
            <section className="tripjack-suppliers-section">
              <div className="tripjack-container">
                {/* Section Header */}
                <div className="tripjack-suppliers-header">
                  <span className="tripjack-suppliers-badge">
                    <i className="ri-handshake-line"></i> OUR INTEGRATED SUPPLIERS
                  </span>
                  <h2 className="tripjack-section-title">
                    Connect With <span className="tripjack-accent">Leading Travel Suppliers</span>
                  </h2>
                  <p className="tripjack-section-subtitle">
                    Direct integrations with industry-leading travel suppliers worldwide
                  </p>
                </div>

                {/* Clickable Logo Grid */}
                <div className="tripjack-logo-grid">
                  {suppliers.map((supplier) => (
                    <div 
                      key={supplier.id} 
                      className="tripjack-logo-item tripjack-clickable"
                      onClick={() => handleSupplierClick(supplier.path)}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleSupplierClick(supplier.path);
                        }
                      }}
                    >
                      <div className="tripjack-logo-wrapper">
                        <img 
                          src={supplier.logo} 
                          alt={supplier.name}
                          className="tripjack-supplier-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://via.placeholder.com/80x40?text=${supplier.name.charAt(0)}`;
                          }}
                        />
                      </div>
                      <span className="tripjack-logo-name">{supplier.name}</span>
                      <span className="tripjack-view-details-hint">
                        View Details <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  ))}
                </div>

                {/* Simple Stats */}
                <div className="tripjack-supplier-stats-simple">
                  
                  <div className="tripjack-stat-simple">
                    <span className="tripjack-stat-number">1M+</span>
                    <span className="tripjack-stat-label">Hotel Properties</span>
                  </div>
                  <div className="tripjack-stat-simple">
                    <span className="tripjack-stat-number">80+</span>
                    <span className="tripjack-stat-label">Airlines</span>
                  </div>
                  <div className="tripjack-stat-simple">
                    <span className="tripjack-stat-number">300K+</span>
                    <span className="tripjack-stat-label">Activities</span>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'pricing' && (
            <section className="tripjack-pricing-section">
              <div className="tripjack-container">
                <div className="tripjack-pricing-header">
                  <h2 className="tripjack-section-title tripjack-text-center">
                    Plans & <span className="tripjack-accent">Pricing</span>
                  </h2>
                  <p className="tripjack-section-subtitle">
                    Pick the plan that's right for your business growth
                  </p>
                  
                  {/* Billing Toggle */}
                  <div className="tripjack-billing-toggle">
                    <button
                      className={`tripjack-toggle-btn ${billingCycle === 1 ? 'tripjack-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(1)}
                    >
                      Monthly
                    </button>
                    <button
                      className={`tripjack-toggle-btn ${billingCycle === 2 ? 'tripjack-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(2)}
                    >
                      Annually
                      <span className="tripjack-save-badge">Save 20%</span>
                    </button>
                  </div>
                </div>

                {/* Pricing Cards */}
                <div className="tripjack-pricing-grid">
                  {plans.map((plan) => {
                    const isMonthly = billingCycle === 1;
                    const accentColor = getAccentColor(plan.name);
                    
                    return (
                      <div key={plan.id} className="tripjack-pricing-card-enhanced">
                        {plan.popular && (
                          <div className="tripjack-popular-badge">
                            ⭐ MOST POPULAR
                          </div>
                        )}

                        <div className="tripjack-pricing-card-content">
                          {/* Pricing Side */}
                          <div className="tripjack-pricing-left" style={{ backgroundColor: plan.popular ? '#F4F9FF' : '#ffffff' }}>
                            <div className="tripjack-pricing-emoji">{plan.emoji}</div>
                            <h3 className="tripjack-pricing-name">{plan.name}</h3>
                            <p className="tripjack-pricing-description">{plan.description}</p>

                            <div className="tripjack-pricing-amount">
                              <span className="tripjack-currency">INR</span>
                              <span className="tripjack-price">
                                {isMonthly ? plan.monthly.toLocaleString() : plan.annually.toLocaleString()}
                              </span>
                              <span className="tripjack-pricing-period">
                                /{isMonthly ? 'month' : 'year'}
                              </span>
                            </div>

                            <button 
                              className="tripjack-pricing-cta"
                              style={{ backgroundColor: accentColor }}
                              onClick={() => window.location.href = '/signup'}
                            >
                              Start Free Trial <i className="ri-arrow-right-line"></i>
                            </button>

                            {/* Quick 3-Step Setup */}
                            <div className="tripjack-quick-setup">
                              <h4 className="tripjack-setup-title">Quick 3-Step Setup</h4>
                              <div className="tripjack-setup-steps">
                                <div className="tripjack-setup-step">
                                  <div className="tripjack-step-marker" style={{ background: accentColor }}>1</div>
                                  <div className="tripjack-step-content">
                                    <strong>Sign Up & Choose Plan</strong>
                                    <span>Create your account in 30 seconds - no credit card required</span>
                                  </div>
                                </div>
                                <div className="tripjack-setup-step">
                                  <div className="tripjack-step-marker" style={{ background: accentColor }}>2</div>
                                  <div className="tripjack-step-content">
                                    <strong>Select Your Suppliers</strong>
                                    <span>Choose from leading travel suppliers with one click</span>
                                  </div>
                                </div>
                                <div className="tripjack-setup-step">
                                  <div className="tripjack-step-marker" style={{ background: accentColor }}>3</div>
                                  <div className="tripjack-step-content">
                                    <strong>Launch Your Portal</strong>
                                    <span>Go live with your branded website in minutes</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Features Side */}
                          <div className="tripjack-pricing-right">
                            <h5 className="tripjack-features-title" style={{ color: accentColor }}>
                              Included in {plan.name}
                            </h5>
                            
                            <div className="tripjack-features-list">
                              {plan.features.map((feature, index) => (
                                <div key={index} className="tripjack-feature-item">
                                  <div className="tripjack-feature-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-check-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{feature}</span>
                                </div>
                              ))}
                            </div>

                            <h5 className="tripjack-features-title tripjack-addons-title" style={{ color: accentColor }}>
                              Add-Ons
                            </h5>
                            
                            <div className="tripjack-addons-list">
                              {plan.addons.map((addon, index) => (
                                <div key={index} className="tripjack-addon-item">
                                  <div className="tripjack-addon-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-add-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{addon}</span>
                                </div>
                              ))}
                            </div>

                            <div className="tripjack-pricing-footer">
                              <span>✓ Transparent pricing, no hidden fees</span>
                              <span className="tripjack-support-link" style={{ color: accentColor }}>
                                Need help? Chat with us
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          )}
        </div>
      </div>

      {/* Styles with tripjack- prefix */}
      <style jsx>{`
        .tripjack-supplier-container {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
          line-height: 1.6;
          color: #1e293b;
        }

        .tripjack-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Header Styles */
        .tripjack-header {
          background: #ffffff;
          color: #1e293b;
          padding: 80px 0 40px;
          text-align: center;
        }

        .tripjack-title {
          font-size: 3.5rem;
          font-weight: 800;
          margin: 0 0 15px;
          line-height: 1.2;
          color: #1e293b;
        }

        .tripjack-highlight {
          font-size: 4rem;
          display: inline-block;
          font-weight: 800;
        }

        .tripjack-subtitle {
          font-size: 1.25rem;
          max-width: 700px;
          margin: 0 auto;
          color: #475569;
        }

        /* Tabs Navigation */
        .tripjack-tabs-container {
          background: #ffffff;
          border-bottom: 2px solid #e2e8f0;
          margin-bottom: 40px;
          position: sticky;
          top: 0;
          z-index: 100;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }

        .tripjack-tabs {
          display: flex;
          gap: 30px;
          overflow-x: auto;
          padding: 0 24px;
        }

        .tripjack-tab {
          background: none;
          border: none;
          padding: 16px 0;
          font-size: 1rem;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          position: relative;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
        }

        .tripjack-tab:hover {
          color: #0f172a;
        }

        .tripjack-tab-active {
          color: #0f172a;
        }

        .tripjack-tab-active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 3px;
          background: ${tripjackData.themeColor};
        }

        .tripjack-tab-badge {
          background: ${tripjackData.themeColor};
          color: white;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          font-weight: 500;
        }

        /* About Section */
        .tripjack-about {
          padding: 40px 0 60px;
          background: #ffffff;
        }

        .tripjack-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 50px;
          align-items: start;
        }

        .tripjack-section-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .tripjack-text-center {
          text-align: center;
        }

        .tripjack-accent {
          position: relative;
          display: inline-block;
        }

        .tripjack-accent::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100%;
          height: 4px;
          background: ${tripjackData.themeColor};
          border-radius: 2px;
        }

        .tripjack-text {
          font-size: 1.1rem;
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.8;
        }

        .tripjack-features {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          margin-top: 30px;
        }

        .tripjack-feature {
          display: flex;
          gap: 15px;
          padding: 20px;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .tripjack-feature:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          border-color: ${tripjackData.themeColor};
        }

        .tripjack-feature-icon {
          font-size: 2rem;
          min-width: 50px;
        }

        .tripjack-feature h4 {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 5px;
          color: #0f172a;
        }

        .tripjack-feature p {
          font-size: 0.95rem;
          color: #475569;
          margin: 0;
        }

        .tripjack-card {
          background: white;
          padding: 40px;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
        }

        .tripjack-card-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .tripjack-mt-4 {
          margin-top: 30px;
        }

        .tripjack-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .tripjack-list-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          font-size: 1rem;
          color: #334155;
        }

        .tripjack-check {
          font-weight: bold;
          font-size: 1.2rem;
        }

        .tripjack-gds-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .tripjack-gds-tag {
          background: #f1f5f9;
          color: #334155;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 500;
          border: 1px solid #e2e8f0;
        }

        /* Services Section */
        .tripjack-services {
          padding: 40px 0 60px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .tripjack-section-subtitle {
          font-size: 1.25rem;
          color: #475569;
          text-align: center;
          max-width: 700px;
          margin: 0 auto 50px;
        }

        .tripjack-services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .tripjack-service-card {
          background: white;
          padding: 35px 25px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
        }

        .tripjack-service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: ${tripjackData.themeColor};
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .tripjack-service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(37, 99, 235, 0.1);
        }

        .tripjack-service-card:hover::before {
          transform: scaleX(1);
        }

        .tripjack-service-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }

        .tripjack-service-title {
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .tripjack-service-description {
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .tripjack-service-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .tripjack-service-list-item {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          color: #475569;
          font-size: 0.95rem;
        }

        .tripjack-dot {
          font-weight: bold;
        }

        /* Technology Section */
        .tripjack-technology {
          padding: 40px 0 60px;
          background: white;
        }

        .tripjack-integration-box,
        .tripjack-benefits-box {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          padding: 40px;
          border-radius: 24px;
          border: 1px solid #eef2f6;
        }

        .tripjack-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 25px;
        }

        .tripjack-tag {
          background: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-size: 0.9rem;
          color: ${tripjackData.themeColor};
          font-weight: 500;
          border: 1px solid ${tripjackData.themeColor}30;
          transition: all 0.3s ease;
        }

        .tripjack-tag:hover {
          background: ${tripjackData.themeColor};
          color: white;
          border-color: ${tripjackData.themeColor};
          transform: scale(1.05);
        }

        .tripjack-benefits-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .tripjack-benefits-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          font-size: 1.1rem;
          color: #1e293b;
        }

        .tripjack-benefits-icon {
          font-size: 1.5rem;
          background: white;
          width: 45px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        /* Why Zotrai Section */
        .tripjack-why-zotrai-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .tripjack-why-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .tripjack-why-badge {
          display: inline-block;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
        }

        .tripjack-benefits-grid-full {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
          margin-bottom: 50px;
        }

        .tripjack-benefit-card {
          display: flex;
          gap: 20px;
          background: #f8fafc;
          padding: 25px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
        }

        .tripjack-benefit-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.05);
          border-color: ${companyInfo.themeColor};
        }

        .tripjack-benefit-icon-wrapper {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .tripjack-benefit-icon-wrapper i {
          font-size: 2rem;
        }

        .tripjack-benefit-content h3 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 8px;
          color: #0f172a;
        }

        .tripjack-benefit-content p {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 12px;
          line-height: 1.6;
        }

        .tripjack-benefit-stat {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .tripjack-stat-highlight {
          font-size: 1.2rem;
          font-weight: 700;
        }

        .tripjack-integration-process {
          text-align: center;
          margin: 60px 0;
        }

        .tripjack-process-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 40px;
          color: #0f172a;
        }

        .tripjack-process-steps {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .tripjack-process-step {
          text-align: center;
          padding: 30px;
          background: #f8fafc;
          border-radius: 20px;
          border: 1px solid #eef2f6;
        }

        .tripjack-process-step .tripjack-step-number {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 auto 20px;
        }

        /* Contact Section */
        .tripjack-contact-section {
          background: #ffffff;
          padding: 60px;
          border-radius: 30px;
          text-align: center;
          color: #0f172a;
          margin-top: 60px;
          border: 2px solid #eef2f6;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        }

        .tripjack-contact-section h3 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .tripjack-contact-section p {
          font-size: 1.2rem;
          color: #475569;
          margin-bottom: 40px;
        }

        .tripjack-contact-info {
          display: flex;
          justify-content: center;
          gap: 30px;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }

        .tripjack-contact-item {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 20px 30px;
          background: #f8fafc;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 280px;
        }

        .tripjack-contact-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border-color: ${companyInfo.themeColor};
        }

        .tripjack-contact-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .tripjack-contact-icon i {
          font-size: 1.8rem;
        }

        .tripjack-contact-details {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .tripjack-contact-label {
          font-size: 0.85rem;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .tripjack-contact-value {
          font-size: 1.2rem;
          font-weight: 600;
          color: #0f172a;
        }

        .tripjack-contact-note {
          font-size: 0.95rem !important;
          color: #64748b !important;
          margin-top: 20px;
          margin-bottom: 0 !important;
        }

        /* Suppliers Section */
        .tripjack-suppliers-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .tripjack-suppliers-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .tripjack-suppliers-badge {
          display: inline-block;
          background: linear-gradient(135deg, #2563eb15, #7c3aed15);
          color: #2563eb;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
          border: 1px solid #2563eb20;
        }

        .tripjack-suppliers-badge i {
          margin-right: 8px;
        }

        .tripjack-logo-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          margin-bottom: 50px;
        }

        .tripjack-logo-item {
          text-align: center;
          padding: 20px;
          background: white;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .tripjack-logo-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(37, 99, 235, 0.15);
          border-color: #2563eb;
        }

        .tripjack-logo-item:hover .tripjack-view-details-hint {
          opacity: 1;
          transform: translateY(0);
        }

        .tripjack-logo-wrapper {
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 15px;
        }

        .tripjack-supplier-logo {
          max-width: 120px;
          max-height: 60px;
          object-fit: contain;
          transition: transform 0.3s ease;
        }

        .tripjack-logo-item:hover .tripjack-supplier-logo {
          transform: scale(1.05);
        }

        .tripjack-logo-name {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1e293b;
          display: block;
          margin-bottom: 5px;
        }

        .tripjack-view-details-hint {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
          color: #2563eb;
          font-weight: 500;
          opacity: 0;
          transform: translateY(10px);
          transition: all 0.3s ease;
        }

        .tripjack-supplier-stats-simple {
          display: flex;
          justify-content: space-around;
          align-items: center;
          background: linear-gradient(135deg, #f8fafc, #ffffff);
          padding: 30px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          flex-wrap: wrap;
          gap: 20px;
        }

        .tripjack-stat-simple {
          text-align: center;
        }

        .tripjack-stat-simple .tripjack-stat-number {
          display: block;
          font-size: 2rem;
          font-weight: 800;
          color: #2563eb;
          line-height: 1.2;
        }

        .tripjack-stat-simple .tripjack-stat-label {
          font-size: 0.9rem;
          color: #64748b;
        }

        /* Pricing Section */
        .tripjack-pricing-section {
          padding: 40px 0 80px;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        }

        .tripjack-pricing-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .tripjack-billing-toggle {
          display: inline-flex;
          background: white;
          padding: 4px;
          border-radius: 50px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          margin-top: 20px;
        }

        .tripjack-toggle-btn {
          border: none;
          padding: 12px 32px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: transparent;
          color: #64748b;
          position: relative;
        }

        .tripjack-toggle-active {
          background: #2563eb;
          color: white;
        }

        .tripjack-save-badge {
          background: #fbbf24;
          color: #1e293b;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          margin-left: 8px;
          font-weight: 500;
        }

        .tripjack-pricing-grid {
          max-width: 1000px;
          margin: 0 auto;
        }

        .tripjack-pricing-card-enhanced {
          background: white;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .tripjack-pricing-card-enhanced:hover {
          transform: translateY(-5px);
          box-shadow: 0 30px 60px rgba(37, 99, 235, 0.12);
        }

        .tripjack-popular-badge {
          position: absolute;
          top: 20px;
          right: 30px;
          background: #2563eb;
          color: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.85rem;
          z-index: 10;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

        .tripjack-pricing-card-content {
          display: grid;
          grid-template-columns: 1fr 1.2fr;
        }

        .tripjack-pricing-left {
          padding: 40px;
          border-right: 1px solid #eef2f6;
        }

        .tripjack-pricing-emoji {
          font-size: 2.5rem;
          margin-bottom: 15px;
        }

        .tripjack-pricing-name {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 10px;
          color: #0f172a;
        }

        .tripjack-pricing-description {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 25px;
        }

        .tripjack-pricing-amount {
          margin-bottom: 25px;
        }

        .tripjack-currency {
          font-size: 1.2rem;
          font-weight: 600;
          color: #64748b;
          margin-right: 5px;
        }

        .tripjack-price {
          font-size: 3.5rem;
          font-weight: 800;
          color: #0f172a;
          line-height: 1;
        }

        .tripjack-pricing-period {
          font-size: 1rem;
          color: #64748b;
          margin-left: 5px;
        }

        .tripjack-pricing-cta {
          width: 100%;
          border: none;
          padding: 16px;
          border-radius: 12px;
          color: white;
          font-weight: 600;
          font-size: 1.1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-bottom: 30px;
        }

        .tripjack-pricing-cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }

        .tripjack-quick-setup {
          background: #f8fafc;
          border-radius: 16px;
          padding: 20px;
        }

        .tripjack-setup-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          color: #0f172a;
        }

        .tripjack-setup-steps {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .tripjack-setup-step {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .tripjack-step-marker {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 0.9rem;
          flex-shrink: 0;
        }

        .tripjack-step-content {
          display: flex;
          flex-direction: column;
        }

        .tripjack-step-content strong {
          font-size: 0.95rem;
          margin-bottom: 4px;
        }

        .tripjack-step-content span {
          font-size: 0.85rem;
          color: #64748b;
        }

        .tripjack-pricing-right {
          padding: 40px;
          background: #ffffff;
        }

        .tripjack-features-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .tripjack-addons-title {
          margin-top: 30px;
        }

        .tripjack-features-list,
        .tripjack-addons-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .tripjack-feature-item,
        .tripjack-addon-item {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .tripjack-feature-check,
        .tripjack-addon-check {
          width: 22px;
          height: 22px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .tripjack-feature-check i,
        .tripjack-addon-check i {
          font-size: 14px;
        }

        .tripjack-feature-item span,
        .tripjack-addon-item span {
          font-size: 0.95rem;
          color: #334155;
          line-height: 1.5;
        }

        .tripjack-pricing-footer {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
        }

        .tripjack-support-link {
          cursor: pointer;
          font-weight: 500;
        }

        .tripjack-support-link:hover {
          text-decoration: underline;
        }

        /* Accessibility */
        .tripjack-clickable:focus-visible {
          outline: 3px solid #2563eb;
          outline-offset: 2px;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .tripjack-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
          
          .tripjack-services-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .tripjack-benefits-grid-full {
            grid-template-columns: 1fr;
          }

          .tripjack-process-steps {
            grid-template-columns: 1fr;
          }

          .tripjack-logo-grid {
            grid-template-columns: repeat(3, 1fr);
          }

          .tripjack-pricing-card-content {
            grid-template-columns: 1fr;
          }

          .tripjack-pricing-left {
            border-right: none;
            border-bottom: 1px solid #eef2f6;
          }

          .tripjack-contact-info {
            flex-direction: column;
            align-items: center;
          }

          .tripjack-contact-item {
            width: 100%;
            max-width: 400px;
          }
        }

        @media (max-width: 768px) {
          .tripjack-title {
            font-size: 2.5rem;
          }
          
          .tripjack-highlight {
            font-size: 3rem;
          }
          
          .tripjack-tabs {
            gap: 20px;
            overflow-x: auto;
            padding-bottom: 5px;
          }
          
          .tripjack-tab {
            font-size: 0.95rem;
            white-space: nowrap;
          }
          
          .tripjack-services-grid {
            grid-template-columns: 1fr;
          }
          
          .tripjack-section-title {
            font-size: 2rem;
          }

          .tripjack-features {
            grid-template-columns: 1fr;
          }

          .tripjack-logo-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .tripjack-supplier-stats-simple {
            flex-direction: column;
            gap: 20px;
          }

          .tripjack-contact-section {
            padding: 40px 20px;
          }

          .tripjack-contact-section h3 {
            font-size: 1.8rem;
          }

          .tripjack-contact-item {
            padding: 15px 20px;
          }

          .tripjack-contact-value {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .tripjack-header {
            padding: 60px 0 30px;
          }

          .tripjack-logo-grid {
            grid-template-columns: 1fr;
          }

          .tripjack-pricing-left,
          .tripjack-pricing-right {
            padding: 25px;
          }

          .tripjack-price {
            font-size: 2.5rem;
          }

          .tripjack-billing-toggle {
            flex-direction: column;
            width: 100%;
            border-radius: 12px;
          }

          .tripjack-toggle-btn {
            width: 100%;
          }

          .tripjack-contact-item {
            flex-direction: column;
            text-align: center;
          }

          .tripjack-contact-details {
            align-items: center;
          }
        }
      `}</style>
    </>
  );
};

// Simple Helmet component for meta tags
const Helmet = ({ children }) => {
  return <>{children}</>;
};

export default TripjackSupplierHighlight;